<template>
    <div class="assignment-user">
        <el-card class="filter-card">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-content"
                               style="height: 40px; background-color: white;line-height: 40px; border-radius: 4px;text-indent: 10px;">
                    <el-breadcrumb-item to="/sys/user">用户管理</el-breadcrumb-item>
                    <el-breadcrumb-item>角色分配</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="top-content">
                <el-form :inline="true" :model="params" class="demo-form-inline" label-width="60px;">
                    <el-form-item label="用户名称">
                        <el-input v-model="params.userName" placeholder="请输入用户名称" disabled></el-input>
                    </el-form-item>
                </el-form>
                <el-pagination
                    background
                    class="pagination"
                    layout="prev, pager, next"
                    @current-change="changePage"
                    :total="totalCount">
                </el-pagination>
            </div>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px;">
            <el-table
                :data="roleList"
                ref="multipleTableClinicRoom"
                :header-cell-style="{background: '#eef1f6', color: '#606266', fontWeight: 'bolder'}"
                style="width: 100%"
                v-loading="loading"
                @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    width="55"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="roleName"
                    label="角色名称"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="dataScope"
                    label="数据范围"
                    align="center">
                </el-table-column>
                <el-table-column
                    label="创建时间"
                >
                    <template slot-scope="scope">
                        {{ scope.row.createdTime | moment }}
                    </template>
                </el-table-column>
            </el-table>
            <div class="save-btn">
                <el-button size="small" type="success" icon="el-icon-check" @click="saveInfo('ruleForm')">保存</el-button>
                <el-button size="small" type="danger" icon="el-icon-close" @click="$router.back()">关闭</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import { getRoleInfo, assignmentRole } from '@/api/usermange';

export default {
    name: "UserAssignRole",
    data() {
        return {
            loading: false,
            roleList: [],
            totalCount: null,
            params: {
                pageNo: 1,
                pageSize: 10,
                companyId: this.$route.query.companyId,
                roleName: '',
                userId: this.$route.query.id,
                userName: this.$route.query.name,
            },
            query: {
                userCode: this.$route.query.id,
                companyId: this.$route.query.companyId,
                roleIds: []
            },
            multipleSelection: []
        }
    },
    created() {
        this.getRoleDataList()
    },
    methods: {
        async getRoleDataList() {
            this.loading = true
            const res = await getRoleInfo(this.params)
            if (res.code === '200') {
                this.roleList = res.data.list
                this.roleList.forEach((item,index)=>{
                    if(item.checkStatus){
                        this.$nextTick(() => {
                            this.$refs.multipleTableClinicRoom.toggleRowSelection(this.roleList[index], true)
                        })
                    }
                })
                this.totalCount = res.data.total
            }
            this.loading = false
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async saveInfo(){
            this.multipleSelection.forEach(item => {
                this.query.roleIds.push(item.roleId)
            })
            const res = await assignmentRole(this.query);
            if(res.code === '200'){
                this.$message.success('修改成功')
            }else{
                this.$message.error(res.msg)
            }
        },
        changePage(e){
            this.params.pageNo = e
            this.getRoleDataList()
        }
    }
}
</script>

<style scoped>
::v-deep .el-card__header {
    padding: 10px 20px;
}

::v-deep .el-card__body {
    padding: 20px 10px;
}

::v-deep .el-form-item {
    margin-bottom: 0;
}
</style>
<style scoped lang="scss">
.top-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
}

.save-btn {
    margin-top: 30px;
    text-align: center;
}
</style>
